import { stringConfig } from '../components/avatar/avatar.config'

/**
 * @description Create an image src string for a `contact.fullname`
 * @param {{string: String, width: Number, height: Number, bgColor: String, fontWeight: String, fontScale: Number, pictureFormat: String, textColor: String}} config
 * @return {String}
 */
export function generateAvatar(config) {
  const {
    str,
    width,
    height,
    bgColor,
    pictureFormat,
    fontWeight,
    fontScale,
    textColor,
  } = checkValues(config)

  // render canvas and get the data URL
  const canvas = document.createElement('canvas')
  canvas.id = `vueAvatar-${Date.now()}`
  canvas.width = width
  canvas.height = height

  const context = canvas.getContext('2d')
  context.fillStyle = bgColor
  context.fillRect(0, 0, width, height)

  const fS = width / (2 / (fontScale / 100))
  const fW = width / 2
  const fH = height - (height / 2) + (fS / 3) + 1

  context.font = `${fontWeight} ${fS}px "Open Sans", Helvetica, Arial, sans-serf`
  context.textAlign = 'center'
  context.fillStyle = textColor
  context.fillText(str, fW, fH)

  return canvas.toDataURL('image/' + pictureFormat)
}

/**
 * @private
 * @description quick internal check used in the check values
 * @param {*} value
 * @param {String} type
 * @return {Boolean}
 */
const expect = (value, type = null) => {
  if (type)
    return value !== null && value !== undefined && typeof value === type
  return value !== null && value !== undefined
}

/**
 * @private
 * @description Check values and add them to the config
 * @param {{string: String, width: Number, height: Number, bgColor: String, fontWeight: String, fontScale: Number, pictureFormat: String, textColor: String}} config
 * @return {{string: String, width: Number, height: Number, bgColor: String, fontWeight: String, fontScale: Number, pictureFormat: String, autoColor: Boolean, colorPalette: Array<String>, long: Number, textColor: String}}
 */
function checkValues(config) {
  const {
    string,
    width,
    height,
    bgColor,
    fontWeight,
    fontScale,
    pictureFormat,
    pictureResolution,
    textColor,
  } = config
  const c = stringConfig
  if (expect(string, 'string')) c.str = getInitialsFromString(string)
  if (
    expect(width, 'number') &&
    width > 0 &&
    expect(height, 'number') &&
    height > 0
  ) {
    c.width = width
    c.height = height
    c.long = c.width
  }
  if (expect(bgColor, 'string')) {
    c.bgColor = bgColor
    config.autoColor = false
  }
  if (expect(fontWeight, 'string')) c.fontWeight = fontWeight
  if (expect(fontScale, 'number')) c.fontScale = fontScale
  if (expect(pictureFormat, 'string')) c.pictureFormat = pictureFormat
  if (expect(pictureResolution, 'number'))
    c.pictureResolution = pictureResolution
  if (expect(textColor, 'string')) c.textColor = textColor
  if (c.autoColor === true) {
    let i,
      lon = c.str.length,
      charIndex = 0,
      colorIndex
    for (i = 0; i < lon; i++) charIndex = c.str.charCodeAt(i)
    colorIndex = charIndex % c.colorPalette.length
    c.bgColor = c.colorPalette[colorIndex]
  }
  return c
}

/**
 * @private
 * @description Returns the first letter of a contact first name and last name from there full name
 * @param {String} string
 * @return {String}
 */
function getInitialsFromString(string) {
  let output = ''
  string = string.split(' ')
  const len = string.length
  for (let i = 0; i < len; i++) {
    if (string[i] !== '') output += string[i][0].toUpperCase()
  }
  return output.substring(0, 2)
}
